export const ResourceTypes = {
  Human: 'Human',
  Facility: 'Facility',
  System: 'System',
  'Platform / Capability': 'Salesforce Logos and Icons',
  Industry: 'Additional Salesforce icons',
  Flow: 'Flow',
  Object: 'Object'
} as const;

export const ResourceSystemTypes = {Custom: 'Custom', Salesforce: 'Salesforce'} as const;
